import React, {useState} from "react";
import "../../assets/styles/components/selectBoxTree.scss";
import ArrowLeftSelect from "../../assets/svg/arrow-left-select-tree.svg";
import ActiveArrowSelect from "../../assets/svg/active-arrow-left-select-tree.svg";
import DeleteSelect from "../../assets/svg/icon-delete-select-tree.svg";
import EditSelect from "../../assets/svg/icon-edit-select-tree.svg";
import AddSelect from "../../assets/svg/icon-add-select-tree.svg";
import CloseIconInputs from "../../assets/svg/close-icon-inputs.svg";
import confrmCategory from "../../assets/svg/confrmCategory.svg";

export default function TreeSelectBox(props) {
    const {
        accounting = false,
        input,
        depth,
        items,
        selectItem,
        editItem,
        addItem,
        deleteItem,
        value,
        editingItem,
        setEditingItem,
    } = props;
    const [showChildren, setShowChildren] = useState(null);
    const title = accounting ? "حساب" : "دسته بندی";

    return items && items.length > 0
        ? items.map((item) => {
            return (
                <>
                    <div
                        className={
                            (item.id === showChildren || depth === 2
                                ? "items-select-box-tree"
                                : "items-select-box-tree") +
                            " " +
                            (value && value.id === item.id ? "activated-items-select-box-tree" : "items-select-box-tree")
                        }
                        style={
                            item.depth > 1 ? {paddingRight: `${depth * 20}px`} : {paddingRight: `${depth * 10}px`}
                        }
                    >
                        {item.childs && item.childs.length > 0 ? (
                            <>
                                <img
                                    className="default-arrow-left-select"
                                    onClick={() => setShowChildren(item.id)}
                                    src={ArrowLeftSelect}
                                    alt="ArrowLeftSelect"
                                />
                                <img
                                    className="active-arrow-left-select"
                                    onClick={() => setShowChildren(null)}
                                    src={ActiveArrowSelect}
                                    alt="ActiveArrowSelect"
                                />
                            </>
                        ) : null}
                        <div className="text-select-box-tree">
                            <div
                                onClick={() => {
                                    if (input.onlyLastChildSelectable) {
                                        if (!(item.childs && item.childs.length > 0)) {
                                            selectItem(item);
                                        }
                                    } else {
                                        selectItem(item);
                                    }
                                    // setShowChildren(showChildren === item.id ? null : item.id)
                                }}
                            >
                                {(item.accountingCode ? item.accountingCode + " - " : "") + item.title}
                            </div>
                            {input.editable ? (
                                <>
                                    <img
                                        className="icon-add-select-box-tree"
                                        src={AddSelect}
                                        alt="EditSelect"
                                        onClick={() => {
                                            setEditingItem({parentId: item.id});
                                        }}
                                    />
                                    <img
                                        className="icon-edit-select-box-tree"
                                        src={EditSelect}
                                        alt="EditSelect"
                                        onClick={() => {
                                            editItem(item);
                                        }}
                                    />
                                    <img
                                        className="icon-delete-select-box-tree"
                                        src={DeleteSelect}
                                        alt="DeleteSelect"
                                        onClick={() => {
                                            deleteItem(item);
                                        }}
                                    />
                                </>
                            ) : null}
                        </div>
                    </div>

                    {input.editable &&
                    editingItem &&
                    ((editingItem.id && editingItem.id === item.id) ||
                        (!editingItem.id && editingItem.parentId === item.id)) ? (
                        <div className="add-category">
                            <div className="wrap-add-category">
                                <div className="label-add-categoery">
                                    {editingItem
                                        ? !editingItem.id
                                            ? `افزودن ${title}`
                                            : `ویرایش ${title}`
                                        : `${title} جدید`}
                                </div>
                                <input
                                    type="text"
                                    className="input-add-select-box"
                                    onChange={(e) => setEditingItem({...editingItem, title: e.target.value})}
                                    onKeyDown={(e) => {
                                        e.key === "Enter" && addItem();
                                        e.key === "Escape" && setEditingItem(null);
                                    }}
                                    placeholder="عنوان"
                                    maxLength={64}
                                    value={editingItem.title ?? ""}
                                />
                                {/*{accounting && (*/}
                                {/*  <input*/}
                                {/*    type="text"*/}
                                {/*    className="input-add-select-box"*/}
                                {/*    style={{ width: "50%", minWidth: "10px !important" }}*/}
                                {/*    onChange={(e) =>*/}
                                {/*      setEditingItem({*/}
                                {/*        ...editingItem,*/}
                                {/*        accountingCode: e.target.value,*/}
                                {/*      })*/}
                                {/*    }*/}
                                {/*    onKeyDown={(e) => {*/}
                                {/*      e.key === "Enter" && addItem();*/}
                                {/*      e.key === "Escape" && setEditingItem(null);*/}
                                {/*    }}*/}
                                {/*    placeholder="کد حسابداری"*/}
                                {/*    maxLength={5}*/}
                                {/*    value={editingItem.accountingCode ?? ""}*/}
                                {/*  />*/}
                                {/*)}*/}
                                <img
                                    src={CloseIconInputs}
                                    alt="CloseIconInputs"
                                    className="close-icon-category"
                                    onClick={() => setEditingItem(null)}
                                />
                                <img
                                    src={confrmCategory}
                                    alt="confrmCategory"
                                    className="img-confirm-category"
                                    onClick={() => addItem()}
                                />
                            </div>
                        </div>
                    ) : null}

                    {(item.id === showChildren || depth === 2) && item.childs ? (
                        <TreeSelectBox
                            accounting={accounting}
                            input={input}
                            depth={depth + 1}
                            items={item.childs}
                            selectItem={selectItem}
                            editItem={editItem}
                            addItem={addItem}
                            deleteItem={deleteItem}
                            value={value}
                            editingItem={editingItem}
                            setEditingItem={setEditingItem}
                        />
                    ) : (
                        <></>
                    )}
                </>
            );
        })
        : null;
}
